import React from "react";
import { motion } from "framer-motion";
import { WHY_CARDS } from "../data/content";

const ICONS = {
  sparkle: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 2v6M12 16v6M2 12h6M16 12h6M5 5l4 4M15 15l4 4M5 19l4-4M15 9l4-4"/>
    </svg>
  ),
  gauge: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 14a3 3 0 100-6 3 3 0 000 6z"/>
      <path d="M12 2v3M2 12h3M12 22v-3M22 12h-3"/>
      <path d="M12 12l6-4"/>
    </svg>
  ),
  circuit: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="4" y="4" width="16" height="16" rx="1"/>
      <path d="M8 4v3M16 4v3M8 17v3M16 17v3M4 8h3M4 16h3M17 8h3M17 16h3"/>
      <rect x="9" y="9" width="6" height="6" rx="0.5"/>
    </svg>
  ),
  users: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M9 11a4 4 0 100-8 4 4 0 000 8zM17 11a4 4 0 100-8M3 21v-2a5 5 0 015-5h2a5 5 0 015 5v2M17 14a5 5 0 015 5v2"/>
    </svg>
  ),
  eye: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M2 12s3-8 10-8 10 8 10 8-3 8-10 8-10-8-10-8z"/><circle cx="12" cy="12" r="3"/>
    </svg>
  ),
  layers: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 3l10 6-10 6L2 9l10-6z"/><path d="M2 15l10 6 10-6"/>
    </svg>
  ),
  shield: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 2l9 4v6c0 5.5-4 10-9 12-5-2-9-6.5-9-12V6l9-4z"/><path d="M9 12l2 2 4-4"/>
    </svg>
  ),
  bolt: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/>
    </svg>
  ),
};

export default function WhyUs() {
  return (
    <section id="why" className="vw-section relative bg-[var(--vw-bg-soft)]" data-testid="vw-why">
      <div className="vw-container">
        <div className="mb-16 max-w-3xl">
          <div className="vw-eyebrow mb-6">WHY PRODUCERS STOP LOOKING</div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.92] tracking-tight">
            Four <span className="font-serif-italic font-normal">reasons</span>. Not eight bullet points.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--vw-border)]">
          {WHY_CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 2) * 0.08 }}
              className="group relative bg-[var(--vw-bg-soft)] p-8 md:p-12 hover:bg-[var(--vw-surface)] transition-colors min-h-[280px] flex flex-col"
              data-testid={`vw-why-card-${i}`}
            >
              <div className="mb-6 w-14 h-14 grid place-items-center border border-[var(--vw-border-strong)] text-[var(--vw-cyan)] group-hover:border-[var(--vw-cyan)] group-hover:vw-glow-cyan transition-all">
                {ICONS[c.icon]}
              </div>
              <h3 className="font-display text-3xl md:text-4xl leading-[1.02] mb-4 text-[var(--vw-text)] tracking-tight">
                {c.title}
              </h3>
              <p className="text-[15px] md:text-base text-[var(--vw-text-dim)] leading-relaxed max-w-md mb-6">
                {c.body}
              </p>
              {c.proof && (
                <div className="mt-auto pt-5 border-t border-[var(--vw-border)] flex items-center gap-3">
                  <span className="w-1.5 h-1.5 bg-[var(--vw-cyan)]" />
                  <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[var(--vw-cyan)]">
                    {c.proof}
                  </span>
                </div>
              )}
              <span className="absolute bottom-0 left-0 h-px w-0 bg-[var(--vw-cyan)] group-hover:w-full transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
